module.exports = __webpack_public_path__ + "f1e1d4af5eb69948b74f3f4033cca7f7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/hoodie-finger-heart-white.png
// module id = 1298
// module chunks = 0